export default __webpack_public_path__ + "static/media/628.9fca1140.png";